import React from "react";
import { Cat } from "lucide-react";

/**
 * Small brand lockup. `variant` controls how loud it is.
 *   - "compact"  small wordmark for the wizard header
 *   - "hero"     larger for the landing/intro screens
 */
export function Logo({ variant = "compact" }) {
    if (variant === "hero") {
        return (
            <div className="flex flex-col items-start gap-3" data-testid="brand-logo-hero">
                <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-meow-teal text-white shadow-[0_10px_30px_rgba(42,139,139,0.28)]">
                    <Cat className="h-7 w-7" strokeWidth={1.75} aria-hidden />
                </div>
                <div>
                    <div className="font-display text-3xl font-medium tracking-tight text-meow-charcoal">
                        MeowMD
                    </div>
                    <div className="eyebrow mt-1 text-meow-muted">
                        Free Cat Health Check
                    </div>
                </div>
            </div>
        );
    }
    return (
        <div className="flex items-center gap-2" data-testid="brand-logo">
            <div className="flex h-8 w-8 items-center justify-center rounded-xl bg-meow-teal text-white">
                <Cat className="h-4 w-4" strokeWidth={2} aria-hidden />
            </div>
            <span className="font-display text-lg font-medium tracking-tight text-meow-charcoal">
                MeowMD
            </span>
        </div>
    );
}
